import axios, { AxiosResponse } from 'axios';
import { ContentMarkedForDeletion, EditorialType, Node } from '../domain/domain';
import { getHeaders, BASE_URL } from './common';

export function getNodeById(nodeId: number) : Promise<AxiosResponse<Node>> {
    return axios.get(BASE_URL + `/legal/node/${nodeId}`, {headers: getHeaders()});
}

export function getMarkedForDeletionNodes(): Promise<AxiosResponse<Node[]>> {
    return axios.get(BASE_URL + `/legal/node/findAllMarkedForDeletion`, {headers: getHeaders()});
}

export function printMarkedForDeletionNodes(content: ContentMarkedForDeletion[]): Promise<AxiosResponse<string>> {
    return axios({
        url: BASE_URL + `/legal/node/printMarkedForDeletion`,
        method: 'POST',
        data: content,
        responseType: 'blob',
    });
}

export function deleteContent(content: ContentMarkedForDeletion[]): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/deleteContent`, content, {headers: getHeaders()});
}

export function deleteNodeById(nodeId: number): Promise<AxiosResponse<Node>> {
    return axios.delete(BASE_URL + `/legal/node/${nodeId}`, {headers: getHeaders()});
}

export function repealSubtree(nodeId: number): Promise<AxiosResponse<Node[]>> {
    return axios.post(BASE_URL + `/legal/node/${nodeId}/repeal`, {}, {headers: getHeaders()});
}

export function addChildNode(parentNodeId: number, childNode: Node): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/${parentNodeId}`, childNode, {headers:getHeaders()});
}

export function saveNodeById(node: Node): Promise<AxiosResponse<Node>> {
    return axios.put(BASE_URL + `/legal/node/${node.nodeId}`, node, {headers: getHeaders()});
}

export function saveNodeByIdOps(node: Node): Promise<AxiosResponse<Node>> {
    return axios.put(BASE_URL + `/legal/node/ops/${node.nodeId}`, node, {headers: getHeaders()});
}

export function approveNodeChanges(nodeId: number, deep: boolean): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/${nodeId}/approve?deep=${deep}`, "", {headers: getHeaders()});
}

export function rejectNodeChanges(nodeId: number, deep: boolean): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/${nodeId}/reject?deep=${deep}`, "", {headers: getHeaders()});
}

export function saveEditorialContent(node: Node, editorialType: EditorialType, content: any): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/editorial/${node.nodeId}/${editorialType}`, content, {headers: getHeaders()});
}

export function approveEditorialContent(node: Node, editorialType: EditorialType): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/editorial/${node.nodeId}/${editorialType}/approve`, node, {headers: getHeaders()});
}

export function rejectEditorialContent(node: Node, editorialType: EditorialType): Promise<AxiosResponse<Node>> {
    return axios.post(BASE_URL + `/legal/node/editorial/${node.nodeId}/${editorialType}/reject`, node, {headers: getHeaders()});
}

export function deleteAnnotationNodeById(nodeId: number, annoId: number): Promise<AxiosResponse<Node>> {
    return axios.delete(BASE_URL + `/legal/node/editorial/${nodeId}/ANNOTATION/${annoId}`, {headers: getHeaders()});
}
